export const RESET = 'COMPANY_UPDATE_RESET'
export const SET_ERROR = 'COMPANY_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'COMPANY_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'COMPANY_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'COMPANY_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'COMPANY_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'COMPANY_UPDATE_UPDATE_RETRIEVED'



// WEBPACK FOOTER //
// ./src/store/modules/company/update/mutation_types.js